import React from 'react';
import { UiComponents } from "@simulanisindia/ui";
import googleIcon from '../../../assets/img/googleicon.png';
import { useModalContext } from '../../../modal/context/ModalProvider';
import { modalName } from '../../../utils/general';
import { useParams } from 'react-router-dom';

const { NormalGradientButton } = UiComponents;

const Password = ({ userDetails,isMobileView }) => {
    const params = useParams();
    const { openModal } = useModalContext();

    const handleOpenChangePasswordModal = () => {
        openModal({
            modalName: modalName.PASSWORD_CHANGE,
            type: "update",
            UUID: userDetails.uuid,
            params,
            user: {
                email: userDetails.email
            }
        })
    }

    return (
        <>
            <div className="carddata colorborder">
                <div className='profileinfo'>
                    <div>
                        <h6>Password</h6>
                        <p>Password {userDetails.signinGoogle && "not"} set for this account</p>
                    </div>
                    <NormalGradientButton text="Set Password" onClick={handleOpenChangePasswordModal} />
                </div>
                <br />
                {userDetails.signinGoogle && <p className='m-0'><img src={googleIcon} alt="" referrerPolicy="no-referrer" /> You're signing in via Google and haven't set a password yet.</p>}
            </div>

        </>
    );
};

export default Password;